import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
import styled from 'styled-components';
export var TextAreaContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return _extends({}, theme.textArea[variant].container);
});
export var TextAreaInput = styled.textarea(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* width */\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  ", "\n\n  ::placeholder {\n    ", "\n  }\n"])), function (_ref2) {
  var variant = _ref2.variant,
    theme = _ref2.theme;
  return _extends({}, theme.textArea[variant].input);
}, function (_ref3) {
  var variant = _ref3.variant,
    theme = _ref3.theme;
  return _extends({}, theme.textArea[variant].placeholder);
});
export var TextDelimiter = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
export var Characters = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var variant = _ref4.variant,
    theme = _ref4.theme;
  return _extends({}, theme.textArea[variant].counter);
});
export var Wrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var variant = _ref5.variant,
    theme = _ref5.theme;
  return _extends({}, theme.textArea[variant].wrapper);
}, function (_ref6) {
  var focused = _ref6.focused,
    variant = _ref6.variant,
    theme = _ref6.theme;
  return focused ? _extends({}, theme.textArea[variant].wrapperActive) : _extends({}, theme.textArea[variant].wrapper);
});
export var Label = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n"])), function (_ref7) {
  var variant = _ref7.variant,
    theme = _ref7.theme;
  return _extends({}, theme.textArea[variant].label);
}, function (_ref8) {
  var focused = _ref8.focused,
    variant = _ref8.variant,
    theme = _ref8.theme;
  return focused ? _extends({}, theme.textArea[variant].labelActive) : _extends({}, theme.textArea[variant].label);
});
export var Hint = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref9) {
  var variant = _ref9.variant,
    theme = _ref9.theme;
  return _extends({}, theme.textArea[variant].hint);
});